import React from 'react';
import { useSelector } from 'react-redux';

import BomHeader from 'shared/product_tabs/tab_parts/components/import/header/bom_header';
import Workbook from 'shared/product_tabs/tab_parts/components/import/workbook/workbook';
import { selectDataForImportView } from 'shared/product_tabs/tab_parts/slice/selectors';

const BomImport = (props) => {
  const { bom_parameters, validator } = props;

  const {
    name,
    revision,
    board_qtys,
    header,
    first_row,
    ref_des_separator,
    ref_des_range_separator,
    workbook,
  } = useSelector(selectDataForImportView);

  return (
    <>
      <div id='boms'>
        <BomHeader
          name={name}
          revision={revision}
          board_qtys={board_qtys}
          header={header}
          first_row={first_row}
          validator={validator} />
        <hr />
        <Workbook
          ref_des_separator={ref_des_separator}
          ref_des_range_separator={ref_des_range_separator}
          header={header}
          first_row={first_row}
          bom_parameters={bom_parameters}
          workbook={workbook} />
      </div>
    </>
  );
};

export default BomImport;
